var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(item,i){return _c('v-btn',{key:i,staticClass:"mr-2 my-1",attrs:{"to":_vm.localePath({
        name: 'blog-tag-tag',
        params: {
          tag: item.slug
        }
      }),"color":"grey lighten-4","rounded":"","depressed":"","small":item.size == 'Small',"large":item.size == 'Large'}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }